export default __webpack_public_path__ + "static/media/Karnataka1.baa03f30.png";